import { z } from 'zod'

/**
 * Run a Zod schema and return field errors as Record<path, message>.
 * Paths use dot notation (e.g. "personalInfo.firstName", "academicInfo.gpa").
 * Returns empty object when validation succeeds.
 */
export function getFieldErrors<T>(schema: z.ZodType<T>, data: unknown): Record<string, string> {
  const result = schema.safeParse(data)
  if (result.success) return {}

  const errors: Record<string, string> = {}
  for (const issue of result.error.issues) {
    const path = issue.path.filter(Boolean).join('.')
    if (path && !errors[path]) {
      errors[path] = issue.message
    }
  }
  return errors
}
